import { render, staticRenderFns } from "./faturar1.vue?vue&type=template&id=02de2e82&scoped=true"
import script from "./faturar1.vue?vue&type=script&lang=js"
export * from "./faturar1.vue?vue&type=script&lang=js"
import style0 from "./faturar1.vue?vue&type=style&index=0&id=02de2e82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02de2e82",
  null
  
)

export default component.exports